export default __webpack_public_path__ + "static/media/Chaturbhuj_Temple_Orchha.591d3190.jpg";